import { CloudGatewayDiscoveredDevice } from '@shure/cloud/shared/models/devices';
import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';
import { PLACEHOLDER_VALUE } from '@shure/shared/models';

import { CloudGatewayDiscoveredDeviceFragment } from '../graphql/generated/cloud-sys-api';

import { mapDeviceModelFromSysApi } from './utils';

export function mapCloudGatewayDiscoveredDeviceFromSysApi(
	device: CloudGatewayDiscoveredDeviceFragment
): CloudGatewayDiscoveredDevice {
	return {
		hardwareId: device.hardwareId,
		name: device.name,
		model: mapDeviceModelFromSysApi(device.model),
		macAddress: device.macAddress ?? undefined,
		serialNumber: device.serialNumber,
		ipAddress: device.ipAddress ?? undefined,
		roomName: device.roomName ?? undefined,
		firmwareVersion: device.firmwareVersion,
		cloudConnectivityEnabled: device.cloudConnectivityEnabled,
		proxied: device.proxied,
		managedDeviceCount: device.managedDeviceCount,
		managingCloudGateway: device.managingGateway
			? {
					id: device.managingGateway.id,
					name: device.managingGateway.features.name?.name ?? PLACEHOLDER_VALUE,
					model: mapDeviceModelFromSysApi(device.managingGateway.interface.model ?? DeviceModel.UNKNOWN)
				}
			: undefined
	};
}
